
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PortalNotification } from '@/definitions/definitions';

@Component
export default class CPPortalNotification extends Vue {
  @Prop({ required: true })
  public notification!: PortalNotification;

  public acknowledge() {
    this.$store.dispatch('dismissPortalNotification');
  }
}
